import React, { useCallback, useEffect, useMemo, useState } from "react";
import { apiGet } from "./EmailApi";

function EmailPlansSection() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const safePlans = useMemo(() => {
    return Array.isArray(plans) ? plans.filter(Boolean) : [];
  }, [plans]);

  const fetchPlans = useCallback(async () => {
    try {
      setLoading(true);
      setMessage("");

      const data = await apiGet("/api/email/plans");

      if (!data?.success) {
        throw new Error(data?.message || "Failed to load email plans.");
      }

      setPlans(Array.isArray(data?.data) ? data.data : []);
    } catch (error) {
      setPlans([]);
      setMessage(error.message || "Email plans fetch failed.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPlans();

    const intervalId = window.setInterval(fetchPlans, 15000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [fetchPlans]);

  return (
    <div className="email-panel-card">
      <h2>Email Plans</h2>

      {message ? <output className="email-error-box">{message}</output> : null}

      <div className="email-panel-list">
        {loading ? <p>Loading email plans...</p> : null}

        {!loading && safePlans.length === 0 ? <p>No email plans found.</p> : null}

        {safePlans.map((item) => {
          const features = Array.isArray(item.features_list)
            ? item.features_list.join(", ")
            : item.features || "-";

          return (
            <div className="email-panel-item" key={item.id || item.plan_name}>
              <h4>{item.plan_name || item.planName || "Email Plan"}</h4>
              <p>Price: ₹{Number(item.price || 0).toLocaleString("en-IN")}</p>
              <p>Storage: {item.storage_limit || item.storageLimit || "-"}</p>
              <p>Account Limit: {item.account_limit || item.accountLimit || "-"}</p>
              <p>Features: {features}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default EmailPlansSection;